import { closestCenter, DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { IconGripVertical, IconMinus, IconPlus, IconTrashFilled } from '@tabler/icons-react';
import React, { useContext, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { toast } from 'sonner';
import { postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import ToggleBtn from '../../../../components/Toggle/ToggleBtn';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';
import { ensureHttpPrefix } from '../../../../utils/url.utils';

const SocialLinkBlock = ({ dragButton, pageData, linkId, callback, data }) => {

    const socialLinks = [
        {
            sortId: 1,
            name: 'instagram',
            icon: "https://advy.downlink.in/website-assets/v2/instagram.svg",
            regex: /^(https?:\/\/)?(www\.)?(instagram\.com|instagr\.am)/,
            placeholder: 'instagram.com/username'
        }, {
            sortId: 2,
            name: 'facebook',
            icon: "https://advy.downlink.in/website-assets/v2/facebook.svg",
            regex: /^(https?:\/\/)?(www\.)?(facebook\.com|fb\.com)/,
            placeholder: 'facebook.com/pageurl'
        }, {
            sortId: 3,
            name: 'youtube',
            icon: "https://advy.downlink.in/website-assets/v2/youtube.svg",
            regex: /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)/,
            placeholder: 'youtube.com/channel/channelurl'

        }, {
            sortId: 4,
            name: 'whatsapp',
            icon: "https://advy.downlink.in/website-assets/v2/whatsapp.svg",
            regex: /^(https?:\/\/)?(wa\.me|www\.whatsapp\.com)/,
            placeholder: 'wa.me/1234567890'
        }, {
            sortId: 5,
            name: 'telegram',
            icon: "https://advy.downlink.in/website-assets/v2/telegram.svg",
            regex: /^(https?:\/\/)?(www\.)?(telegram\.me|t\.me)/,
            placeholder: 't.me/channelurl'
        }, {
            sortId: 6,
            name: 'tiktok',
            icon: "https://advy.downlink.in/website-assets/v2/tiktok.svg",
            regex: /^(https?:\/\/)?(www\.)?tiktok\.com/,
            placeholder: 'tiktok.com/@username'
        }, {
            sortId: 7,
            name: 'snapchat',
            icon: "https://advy.downlink.in/website-assets/v2/snapchat.svg",
            regex: /^(https?:\/\/)?(www\.)?snapchat\.com/,
            placeholder: 'snapchat.com/username'
        }, {
            sortId: 8,
            name: 'spotify',
            icon: "https://advy.downlink.in/website-assets/v2/spotify.svg",
            regex: /^(https?:\/\/)?(open\.)?spotify\.com/,
            placeholder: 'open.spotify.com/'
        }, {
            sortId: 9,
            name: 'email',
            icon: "https://advy.downlink.in/website-assets/v2/email.svg",
            regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|edu|gov|io|co|in|app|co.in)$/,
            placeholder: 'email@example.com'
        }, {
            sortId: 10,
            name: 'appleMusic',
            icon: "https://advy.downlink.in/website-assets/v2/apple-music.svg",
            regex: /^(https?:\/\/)?(www\.)?music\.apple\.com/,
            placeholder: 'music.apple.com/'
        }, {
            sortId: 11,
            name: 'discord',
            icon: "https://advy.downlink.in/website-assets/v2/discord.svg",
            regex: /^(https?:\/\/)?(www\.)?(discord\.gg|discord\.com)/,
            placeholder: 'discord.com/channelurl'
        }, {
            sortId: 12,
            name: 'linkedin',
            icon: "https://advy.downlink.in/website-assets/v2/linkedin.svg",
            regex: /^(https?:\/\/)?(www\.)?linkedin\.com/,
            placeholder: 'linkedin.com/in/username'
        }, {
            sortId: 13,
            name: 'mastodon',
            icon: "https://advy.downlink.in/website-assets/v2/mastodon.svg",
            regex: /^(https?:\/\/)?[a-zA-Z0-9.-]+\/@([a-zA-Z0-9._-]+)\/?$/,
            placeholder: 'mastodon.social/@username'
        }, {
            sortId: 14,
            name: 'pinterest',
            icon: "https://advy.downlink.in/website-assets/v2/pinterest.svg",
            regex: /^(https?:\/\/)?(www\.)?(pinterest\.com|pin\.it)/,
            placeholder: 'pinterest.com/username'
        }, {
            sortId: 15,
            name: 'reddit',
            icon: "https://advy.downlink.in/website-assets/v2/reddit.svg",
            regex: /^(https?:\/\/)?(www\.)?reddit\.com/,
            placeholder: 'reddit.com/u/username'
        }, {
            sortId: 16,
            name: 'soundcloud',
            icon: "https://advy.downlink.in/website-assets/v2/soundcloud.svg",
            regex: /^(https?:\/\/)?(www\.)?soundcloud\.com/,
            placeholder: 'soundcloud.com/username'
        }, {
            sortId: 17,
            name: 'threads',
            icon: "https://advy.downlink.in/website-assets/v2/threads.svg",
            regex: /^(https?:\/\/)?(www\.)?threads\.net/,
            placeholder: 'threads.net/@username'
        }, {
            sortId: 18,
            name: 'twitch',
            icon: "https://advy.downlink.in/website-assets/v2/twitch.svg",
            regex: /^(https?:\/\/)?(www\.)?twitch\.tv/,
            placeholder: 'twitch.tv/username'
        }, {
            sortId: 19,
            name: 'x',
            icon: "https://advy.downlink.in/website-assets/v2/x.svg",
            regex: /^(https?:\/\/)?(www\.)?(x\.com|twitter\.com)/,
            placeholder: 'x.com/handle'
        }
    ];


    const [selectedSocialLinks, setSelectedSocialLinks] = useState(data?.links || []);

    const mouseSensor = useSensor(MouseSensor)
    const touchSensor = useSensor(TouchSensor)
    const keyboardSensor = useSensor(KeyboardSensor)

    const sensors = useSensors(mouseSensor, touchSensor, keyboardSensor)

    function ContextAwareToggle({ eventKey, callback }) {
        const { activeEventKey } = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(
            eventKey,
            () => callback && callback(eventKey),
        );

        const isCurrentEventKey = activeEventKey === eventKey;

        return (
            <div className="flex items-center rounded-md bg-[#E8EDFC] gap-3 p-2 cursor-pointer" onClick={decoratedOnClick}>
                {dragButton}
                <p className='mb-0 text-sm font-semibold'>Social Links</p>
                <div className="ms-auto"></div>
                <ToggleBtn state={data?.status == 1} onClickFunction={(e) => onBlockStatusUpdate(e)} />
                <button className='bg-white p-1.5 rounded-full' onClick={decoratedOnClick}>{isCurrentEventKey ? <IconMinus size={20} /> : <IconPlus size={20} />}</button>
            </div>

        );
    }

    async function update(postDetails) {
        let postData = {
            linkId: linkId,
            postData: postDetails
        }
        let resp = await postApi(postData, urlApi.editBlockDataOfCard);
        loadingHide();
        if (resp?.responseCode === 200) {
            if (callback) {
                callback();
            }
        }
        if (resp.responseCode === 500) {
            toast.error(resp.message);
        }
    }

    const onBlockStatusUpdate = (e) => {
        e.stopPropagation();
        loadingShow();
        let status = data?.status == 1 ? 2 : 1;
        let postDetails = [{
            "key": "socialLinks.status",
            "value": status
        }]
        update(postDetails);
    }

    const onSocialIconSelect = (item) => {
        let local = [...selectedSocialLinks];
        if (local.some((x) => x.channelName == item?.name)) {
            return;
        }

        let sortIdArray = local.map((x) => x?.sortId)
        let maxSortId = Math.max(...sortIdArray, 1);
        let linkData = { channelName: item?.name, channelLink: null, sortId: maxSortId + 1, icon: item?.icon };
        local.push(linkData);
        setSelectedSocialLinks(local);
    };

    function handleDragEnd(event) {
        const { active, over } = event;
        if (over && active?.id !== over?.id) {
            let local = [...selectedSocialLinks];
            const activeIndex = local.findIndex(item => item.sortId === active.id);
            const overIndex = local.findIndex(item => item.sortId === over.id);
            let newArr = arrayMove(local, activeIndex, overIndex);
            let postData = [{
                key: 'socialLinks.links',
                value: newArr
            }]
            setSelectedSocialLinks(newArr);
            update(postData);
        }
    }

    const handleDeleteDraggableItem = (itemId) => {
        let localPageData = [...selectedSocialLinks]
        const filteredLinks = localPageData?.filter((link) => link.sortId !== itemId);
        localPageData = filteredLinks;
        setSelectedSocialLinks(localPageData);
        let postData = [{
            key: 'socialLinks.links',
            value: localPageData
        }];
        update(postData);
    }

    const onSocialLinkTypeComplete = (e, item) => {
        if (e.target.value) {
            let local = [...selectedSocialLinks];
            let linkData = local.find((x) => x.sortId == item?.sortId);
            let socialLinkData = socialLinks.find((x) => x.name == item?.channelName);
            if (!socialLinkData?.regex.test(e.target.value)) {
                toast.error(socialLinkData?.name + " Link is not valid");
                return;
            }
            linkData.channelLink = linkData?.channelName == 'email' ? e.target.value : ensureHttpPrefix(e.target.value);
            setSelectedSocialLinks(local);
            let filteredSocialLinks = local.filter((x) => x.channelLink);
            let postData = [{
                key: 'socialLinks.links',
                value: filteredSocialLinks
            }];
            update(postData);
        }
    };

    return (

        <div className='w-full rounded-md overflow-hidden border border-[#E8EDFC]'>
            <Accordion>
                <Accordion.Item eventKey="0">
                    <ContextAwareToggle eventKey={"0"} />
                    <Accordion.Body>
                        <div className="p-2">
                            <div className="mb-3">
                                <p className='text-sm mb-2 font-semibold text-[#273144]'>Select your icons</p>
                                <div className="flex gap-2 flex-wrap mb-3">

                                    {
                                        socialLinks?.map((item) => {
                                            return (
                                                <button key={item?.sortId} className={`flex items-center gap-2 px-3 py-1.5 rounded-full border-2 ${pageData?.socialLinks?.some(x => x.channelName == item?.name) ? 'border-primary' : 'border-[#DBE0EB]'}`} onClick={() => onSocialIconSelect(item)}>
                                                    <img src={item?.icon} alt="" className='h-6' />
                                                    <span className='text-sm capitalize'>{item?.name}</span>
                                                </button>
                                            )
                                        })
                                    }
                                </div>


                                <p className='text-sm font-semibold text-[#273144]'>Edit your links</p>

                                {selectedSocialLinks?.length > 0 && <DndContext onDragEnd={handleDragEnd} modifiers={[restrictToVerticalAxis]} collisionDetection={closestCenter} sensors={sensors}>
                                    <SortableContext items={selectedSocialLinks?.map(item => item?.sortId)} strategy={verticalListSortingStrategy}>
                                        {
                                            selectedSocialLinks?.map((item, index) => {
                                                return (
                                                    <SocialDragItem key={item.sortId} socialData={item} nativeData={socialLinks?.find(x => x.name == item?.channelName)} handleDeleteDraggableItem={(itemId) => handleDeleteDraggableItem(itemId)} onSocialLinkTypeComplete={(e, item) => { onSocialLinkTypeComplete(e, item) }} />
                                                )
                                            })
                                        }
                                    </SortableContext>
                                </DndContext>}
                            </div>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    )
}

export default SocialLinkBlock

export const SocialDragItem = ({ socialData, onSocialLinkTypeComplete, handleDeleteDraggableItem, nativeData }) => {

    const { attributes, listeners, setNodeRef, transform, transition, } = useSortable({ id: socialData?.sortId });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
    };
    return (
        <div ref={setNodeRef} style={style}>
            <div className='flex items-center gap-2 mb-2'>
                <button className='cursor-grabbing' {...attributes} {...listeners}>
                    <IconGripVertical />
                </button>
                <img src={socialData?.icon} alt="" className='h-8' />
                <input type="text" name="" id=""
                    onBlur={(e) => onSocialLinkTypeComplete(e, socialData)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            onSocialLinkTypeComplete(e, socialData);
                        }
                    }}
                    placeholder={nativeData?.placeholder}
                    defaultValue={socialData?.channelLink}
                    className='w-full border h-10 p-2 rounded-lg border-[#0000000D] text-sm' />
                <button onClick={() => handleDeleteDraggableItem(socialData?.sortId)}> <IconTrashFilled color='#EB568E' /></button>
            </div>
        </div>
    )
}